import { axios } from '@complispace/cs-design-system';

const baseURL = process.env.CONTENT_ENGINE_URL;
const publishBaseUrl = `${baseURL}/app/publishing`;

const publish = {
  // GET /app/publishing/{publishId}/file-changes
  async getFileDifferences(publishId) {
    return axios.get(`${publishBaseUrl}/${publishId}/file-changes`);
  },

  // GET /app/publishing/{publishId}/pages/{path}/differences
  async getPageDiff(publishId, path) {
    return axios.get(`${publishBaseUrl}/${publishId}/pages/${path}/differences`);
  },

  // POST /app/publishing/{publishId}/accept
  async merge(publishId) {
    return axios.post(`${publishBaseUrl}/${publishId}/accept`);
  },

  // POST /app/publishing
  async publishDraft(
    moduleId,
    releaseNotes,
    moduleToc,
    getEventTrackingData = false,
    isDraftModeEnabled = false
  ) {
    return axios.post(`${publishBaseUrl}`, {
      moduleId,
      moduleToc,
      releaseNotes,
      getEventTrackingData,
      isDraftModeEnabled
    });
  }
};

export default publish;
